import { getStorageUrl } from '@/utils/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useState } from 'react';

interface Props {
    id: number;
    logo: string;
    image?: string; // صورة مفردة اختيارية
    images?: string[]; // مصفوفة صور لاختيار أكثر من صورة
    title: string;
    description: string;
}

const PartnersBanner = ({ activePartner }: { activePartner?: Props }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: false,
        dragFree: true,
        containScroll: 'trimSnaps',
    });

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [mainImage, setMainImage] = useState('');
    const [imageArray, setImageArray] = useState<string[]>([]);

    useEffect(() => {
        if (activePartner) {
            const images = activePartner.images || (activePartner.image ? [activePartner.image] : []);
            console.log('Processed images:', images);
            setImageArray(images);
            if (images.length > 0) {
                setMainImage(images[0]); // تعيين الصورة الرئيسية عند تحميل الشريك
            }
        }
    }, [activePartner]);

    useEffect(() => {
        if (!emblaApi) return;

        emblaApi.on('select', () => {
            const newIndex = emblaApi.selectedScrollSnap();
            setSelectedIndex(newIndex);
            console.log('Selected index:', newIndex);
        });

        emblaApi.reInit();
    }, [emblaApi, imageArray]);

    if (!activePartner || !imageArray.length) {
        return <p>No images to display.</p>;
    }

    return (
        <div className="flex flex-col gap-x-6 md:gap-y-8 sm:gap-y-4 gap-y-3 px-4 py-6 partnerImg">
            <div className="relative w-full">
                <img
                    src={getStorageUrl(mainImage)}
                    alt={activePartner.title}
                    className="lg:rounded-[40px] md:rounded-[33px] sm:rounded-[20px] rounded-[16px] object-cover w-full h-full lg:max-h-[435px] md:max-h-[360px] sm:max-h-[280px] max-h-[200px] aspect-[2/3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#131313] to-transparent opacity-80 lg:rounded-[40px] md:rounded-[33px] sm:rounded-[20px] rounded-[16px]"></div>
            </div>

            {imageArray.length > 1 && (
                <div className="embla mt-4" ref={emblaRef}>
                    <div className="embla__container flex" style={{ gap: '10px' }}>
                        {imageArray.map((image, index) => (
                            <div
                                key={'44-' + index}
                                className={`relative embla__slide cursor-pointer rounded-lg border-2 xl:max-w-[184px] lg:max-w-[160px] md:max-w-[140px] sm:max-w-[110px] max-w-[100px] lg:h-[118px] md:h-[100px] sm:h-[85px] h-[70px] ${
                                    mainImage === image
                                        ? 'border-Grey20 xl:p-2 lg:p-[6px] md:p-1 p-[3px]'
                                        : 'border-transparent'
                                }`}
                                onClick={() => {
                                    setMainImage(image);
                                    emblaApi?.scrollTo(index);
                                }}
                            >
                                {/* <div className="absolute inset-0 bg-gradient-to-b from-black [3%] to-[#2C93F3] [100%] opacity-50 rounded-lg"></div> */}

                                <img
                                    src={getStorageUrl(image)}
                                    alt={`Slide ${index}`}
                                    className="object-cover w-full h-full lg:rounded-[16px] md:rounded-xl sm:rounded-md rounded-sm relative"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <div className="flex flex-col justify-between h-full">
                <div className="flex md:gap-[9.2px] gap-[5px] items-center">
                    <img
                        src={getStorageUrl(activePartner.logo)}
                        alt={activePartner.title}
                        className="object-cover w-full filterLogo lg:max-h-[70px] md:max-h-[55px] max-h-[40px] lg:max-w-[90px] md:max-w-[75px] sm:max-w-[60px] max-w-[50px] h-full"
                    />

                    <h1 className="lg:text-[46.1px] md:text-[42px] sm:text-[36px] text-[32px] font-bold dark:text-Grey20 text-bg-gray">
                        {activePartner.title}
                    </h1>
                </div>
                <p className="lg:text-[16px] flex-grow md:text-[15px] text-[16px] font-normal dark:text-Grey20 text-bg-gray lg:mt-[24px] md:mt-[22px] sm:mt-[17px] mt-[13px]">
                    {activePartner.description}
                </p>
            </div>
        </div>
    );
};

export default PartnersBanner;
